import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["onBackClick"];
import { Box, Heading, Text } from '@wix/design-system';
import React from 'react';
import s from '../SiteGateHeader/siteGateHeader.scss';
import { HeaderWrapper } from '../HeaderWrapper';
import { DomainSearchGateModule } from '../../../module/domainSearchGate.module';
export const AccountGateHeader = _ref => {
  let onBackClick = _ref.onBackClick,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    t = _DomainSearchGateModu.t,
    Trans = _DomainSearchGateModu.Trans;
  return /*#__PURE__*/React.createElement(Box, _extends({
    direction: "vertical",
    align: "center",
    width: "100%",
    gap: "SP8"
  }, props), /*#__PURE__*/React.createElement(HeaderWrapper, {
    onBackClick: onBackClick
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "extraLarge",
    className: s.siteGateHeaderTitle
  }, t('domain_search_gate.domain_gate.account_level.page.title'))), /*#__PURE__*/React.createElement(Text, {
    size: "medium",
    weight: "thin",
    align: "center"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "domain_search_gate.domain_gate.connect.subtitle",
    components: [/*#__PURE__*/React.createElement("b", null)]
  })));
};
//# sourceMappingURL=AccountGateHeader.js.map